import type { Dictionary } from '@placer-ui/types';
import {
    ReportAccess,
    reportAccessActions,
} from 'store/configuration/report-access/slices/report-access-slice';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { Dispatch } from '@reduxjs/toolkit';
import { AppState } from 'store/store';
import { FetchReportChanges } from 'features/insights/store/actions/fetch-report/types';
import { Venue } from 'core/entities/venue/venueAdmin';

export const updateReportAccessOnFiltersOnly = ({
    dispatch,
    reportChanges,
    currentReportAccess,
    venues,
    withSignal,
}: {
    dispatch: ThunkDispatch<AppState, undefined, AnyAction> & Dispatch<any>;
    reportChanges: FetchReportChanges;
    currentReportAccess: Dictionary<ReportAccess>;
    venues: Venue[];
    withSignal: (fn: ((...args: any[]) => void) | undefined, ...args: any[]) => void;
}) => {
    if (reportChanges.filters && !(reportChanges.entities || reportChanges.dates)) {
        const updatedReportAccess = Object.values(currentReportAccess)
            .slice(0, venues.length)
            .reduce<Dictionary<ReportAccess>>((acc, res, index) => {
                const venue = venues[index];
                acc[venue.uid] = res;
                return acc;
            }, {});
        withSignal(dispatch, reportAccessActions.setReportAccess(updatedReportAccess));
    }
};
